const BASE = '$account'

export const CURRENT = `${BASE}/current`
export const LOGIN = `${BASE}/login`
export const USER = `${BASE}/user`
export const LOGINEX = `${BASE}/loginex`
export const LOGINHINT = `${BASE}/loginHint`
export const LOGOUT = `${BASE}/logout`
export const LOGINASSERTION = `${BASE}/loginUserAssertion`
